import React from "react";

const DisplayResetIcon = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path
        d="M4.44448 10.2161C4.199 10.2161 4 10.0148 4 9.76647V4.92146C4 4.51775 4.48518 4.31859 4.76327 4.60815L6.42683 6.34031C9.54704 3.2199 14.5518 3.2199 17.672 6.34031C20.7922 9.46073 20.7656 14.5325 17.6543 17.6529C14.534 20.7824 9.46704 20.7824 6.34682 17.6529C5.03428 16.3403 4.27231 14.5023 4.06089 12.893C3.99621 12.4007 4.398 11.9966 4.88895 11.9966C5.3799 11.9966 5.77029 12.4012 5.83284 12.8938C6.00665 14.2624 6.59282 15.3987 7.59135 16.394C10.0182 18.831 13.9473 18.831 16.3742 16.394C18.801 13.957 18.801 10.0273 16.3742 7.59028C13.9473 5.16229 10.0182 5.25221 7.59135 7.6802L9.29426 9.45315C9.56806 9.73821 9.36839 10.2161 8.97548 10.2161H4.44448Z"
        fillRule="evenodd"
        fill="currentcolor"
        stroke="none"
      />
    </svg>
  );
};

export default DisplayResetIcon;
